import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { LocationInfo } from '../models/locationInfo';
import 'rxjs/add/operator/first';
import { of } from 'rxjs/observable/of';
import { IGoogleTimeZone } from '../models/GoogleTimeZone';
import { environment } from '../../environments/environment';

@Injectable()
export class MapsService {

  constructor(private http: Http) { }

  public getLatLong(location: LocationInfo): Observable<any> {
    let addr;
    if (location.address) {
      addr = location.address.concat(` ${ location.address2 }`);
    }
    else if (location.address2) {
      addr = location.address2;
    }
    else {
      return of([null, location]);
    }
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${ addr }&key=${ environment.gm }`;
    return this.http.get(url).first().map((res: Response) => [res.json(), location]);
  }

  getTimezoneInfo(location: LocationInfo): Promise<IGoogleTimeZone> {
    const timestamp = new Date().getTime() / 1000;
    return new Promise((resolve, reject) => {
      this.http.get(`https://maps.googleapis.com/maps/api/timezone/json?location=${ location.latitude },${ location.longitude }&timestamp=${ timestamp }&key=${ environment.gm }`)
        .first()
        .map((res: Response) => res.json())
        .subscribe(tzData => {
          if (tzData.errorMessage) {
            reject(tzData.errorMessage);
          }
          else {
            resolve(tzData);
          }
        },
          error => reject(error)
        );
    });
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/providers/maps.service.ts